import { useContext } from 'react'

import { SearchContext } from '@/contexts'

export const useSearchContext = () => useContext(SearchContext)
